import script from "./HTMLEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./HTMLEditor.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__